import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxRootState } from "@/types/redux-store";

export type SelectedMediaState = {
  ids: string[];
};

const featureKey = "mediaPickerSelectedMedia" as const;

const initialState: SelectedMediaState = {
  ids: [],
};

function getSelectedMediaState(state: ReduxRootState): SelectedMediaState {
  return (
    (
      state as ReduxRootState & {
        [featureKey]?: SelectedMediaState;
      }
    )[featureKey] ?? initialState
  );
}

const selectedMediaSlice = createSlice({
  name: featureKey,
  initialState,
  reducers: {
    add(state, action: PayloadAction<string>) {
      if (!state.ids.includes(action.payload)) {
        state.ids.push(action.payload);
      }
    },
    addAtIndex(
      state,
      action: PayloadAction<{
        id: string;
        index: number;
      }>
    ) {
      const nextIds = state.ids.filter((id) => id !== action.payload.id);
      nextIds.splice(action.payload.index, 0, action.payload.id);
      state.ids = nextIds;
    },
    remove(state, action: PayloadAction<string>) {
      state.ids = state.ids.filter((id) => id !== action.payload);
    },
    clear() {
      return initialState;
    },
  },
});

export const selectedMediaReducer = selectedMediaSlice.reducer;
export const selectedMediaActions = selectedMediaSlice.actions;

export const selectSelectedMediaIds = createSelector(
  getSelectedMediaState,
  (state) => state.ids
);

export const selectSelectedMediaSet = createSelector(
  selectSelectedMediaIds,
  (ids) => new Set(ids)
);

export const selectSelectedMediaCount = createSelector(
  selectSelectedMediaIds,
  (ids) => ids.length
);
